import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

import { getLikes } from './utils/requests';

export const usePrefetchFileLikes = ({
  fileId,
  userId,
  queryKey,
  railsType,
  showReactions = true,
}) => {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (fileId && railsType && showReactions) {
      queryClient.prefetchQuery({
        queryKey: [queryKey, fileId],
        queryFn: () => getLikes({ fileId, userId, railsType }),
        staleTime: Infinity,
      });
    }
  }, [fileId, showReactions]);
};
